<app-map [mapInitialized]="_mapInitialized" [hasErrorLoadingMap]="_errLoadingMap">
    <ng-content></ng-content>
</app-map>